import { gql } from '@apollo/client';

export const GET_SALES_TIME_SERIES = gql`
  query GetSalesTimeSeries(
    $dateRange: DateRangeInput
    $countries: [String!]
    $customerType: String
    $collectionTitles: [String!]
    $groupByCollection: Boolean
  ) {
    getSalesTimeSeries(
      dateRange: $dateRange
      countries: $countries
      customerType: $customerType
      collectionTitles: $collectionTitles
      groupByCollection: $groupByCollection
    ) {
      date
      collectionTitle
      revenue
      quantity
    }
  }
`;

export const GET_INVENTORY_DATA = gql`
  query GetInventoryData(
    $dateRange: DateRangeInput
    $countries: [String!]
    $customerType: String
  ) {
    getInventoryData(
      dateRange: $dateRange
      countries: $countries
      customerType: $customerType
    ) {
      productId
      productTitle
      productType
      vendor
      tags
      collections
      imageUrl
      totalSold
      totalRevenue
      currentStock
      dailySalesRate
      daysToSoldOut
      isLowStock
      todoStatus
      notes
      isSkipped
      markup
      score
      scoreColor
      # scoreM
      variants {
        variantId
        variantTitle
        sku
        totalSold
        currentStock
        dailySalesRate
        daysToSoldOut
        isLowStock
      }
    }
  }
`;

export const GET_INVENTORY_COUNTRY_OPTIONS = gql`
  query GetInventoryCountryOptions {
    getInventoryCountryOptions
  }
`;

export const GET_LOW_STOCK_PRODUCTS = gql`
  query GetLowStockProducts {
    getLowStockProducts {
      productId
      productTitle
      totalSold
      currentStock
      dailySalesRate
      daysToSoldOut
      isLowStock
      todoStatus
      notes
      variants {
        variantId
        variantTitle
        sku
        totalSold
        currentStock
        dailySalesRate
        daysToSoldOut
        isLowStock
      }
    }
  }
`;

export const UPDATE_INVENTORY_STATUS = gql`
  mutation UpdateInventoryStatus($input: InventoryStatusInput!) {
    updateInventoryStatus(input: $input)
  }
`;

export const GET_INVENTORY_REPLENISHMENTS = gql`
  query GetInventoryReplenishments($limit: Int) {
    getInventoryReplenishments(limit: $limit) {
      replenishmentId
      productId
      productTitle
      imageUrl
      restockedDate
      restockedQuantity
      notes
    }
  }
`;

export const UPDATE_INVENTORY_REPLENISHMENT = gql`
  mutation UpdateInventoryReplenishment(
    $input: InventoryReplenishmentUpdateInput!
  ) {
    updateInventoryReplenishment(input: $input)
  }
`;

export const DELETE_INVENTORY_REPLENISHMENT = gql`
  mutation DeleteInventoryReplenishment($replenishmentId: String!) {
    deleteInventoryReplenishment(replenishmentId: $replenishmentId)
  }
`;

export const SKIP_PRODUCT = gql`
  mutation SkipProduct($productId: String!) {
    skipProduct(productId: $productId)
  }
`;

export const SAVE_INVENTORY_ANALYTICS = gql`
  mutation SaveInventoryAnalytics($dateRange: DateRangeInput) {
    saveInventoryAnalytics(dateRange: $dateRange)
  }
`;

// Query per ottenere la soglia configurabile dell'utente
export const GET_INVENTORY_THRESHOLD = gql`
  query GetInventoryThreshold {
    getInventoryThreshold
  }
`;

// Mutation per aggiornare la soglia configurabile dell'utente
export const UPDATE_INVENTORY_THRESHOLD = gql`
  mutation UpdateInventoryThreshold($threshold: Float!) {
    updateInventoryThreshold(threshold: $threshold)
  }
`;

// Query per generare report AI
export const GENERATE_INVENTORY_AI_REPORT = gql`
  mutation GenerateInventoryAIReport($dateRange: DateRangeInput) {
    generateInventoryAIReport(dateRange: $dateRange)
  }
`;

// Mutation JSON preflight: ritorna html e dati di confronto
export const GENERATE_INVENTORY_AI_REPORT_DATA = gql`
  mutation GenerateInventoryAIReportData($dateRange: DateRangeInput) {
    generateInventoryAIReportData(dateRange: $dateRange)
  }
`;

export const GET_FREQUENTLY_BOUGHT_TOGETHER = gql`
  query GetFrequentlyBoughtTogether($dateRange: DateRangeInput!, $limit: Int) {
    getFrequentlyBoughtTogether(dateRange: $dateRange, limit: $limit) {
      p1_id
      p2_id
      p1_title
      p2_title
      p1_image
      p2_image
      together_orders
      confidence
      affinity
    }
  }
`;
